import { Box } from 'grommet'
import styled, { css } from 'styled-components'
import { Swiper } from 'swiper/react'

export const Wrapper = styled(Box)`
  align-items: center;
  flex-direction: row;
  position: relative;
`

export const StyledSwiper = styled(Swiper)`
  position: static !important;
  width: 100%;

  ${({ theme, $navigationType }) =>
    $navigationType === 'outside'
      ? css`
          margin-bottom: ${theme.newSpaces.md}px;

          & .swiper-button-prev,
          .swiper-button-next {
            color: ${theme.newColors.primary};

            ${theme.below.laptopM`
              display: none;
            `}

            &:hover {
              color: ${theme.newColors.accent};
            }
          }

          & .swiper-button-prev {
            left: ${`-${theme.newSpaces.xl}px`};
          }

          & .swiper-button-next {
            right: ${`-${theme.newSpaces.xl}px`};
          }

          & .swiper-pagination-bullets {
            bottom: -${theme.newSpaces.xs3}px !important;
          }

          & .swiper-pagination-bullet {
            background-color: ${theme.newColors.primary};
          }
        `
      : css`
          & .swiper-button-prev,
          .swiper-button-next {
            color: ${theme.newColors.white};
          }

          & .swiper-button-prev {
            left: ${`${theme.newSpaces.lg}px`};
          }

          & .swiper-button-next {
            right: ${`${theme.newSpaces.lg}px`};
          }

          & .swiper-pagination-bullets {
            bottom: ${theme.newSpaces.xl6}px !important;
            left: ${theme.newSpaces.xl5}px !important;

            ${theme.below.laptopM`
              left: 0 !important;
              bottom: 10px !important;
            `}
          }

          & .swiper-pagination-bullet {
            background-color: ${theme.newColors.white};
          }

          ${theme.below.laptopM`
            & .swiper-button-prev {
              left: 15px;
            }

            & .swiper-button-next {
              right: 15px;
            }
          `}

          ${theme.below.mobileL`
            & .swiper-button-prev {
              display: none;
            }

            & .swiper-button-next {
              display: none;
            }
          `}
        `}

  & .swiper-button-prev,
    .swiper-button-next {
    position: absolute;

    &:hover {
      cursor: pointer;
    }
  }

  & .swiper-pagination-bullet {
    opacity: 1;
  }

  & .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.newColors.secondary};
  }
`
